__webpack_require__.p = "/mah-canon-from-corners-/onboarding/";